import React from "react";

export const BlurredModalOverlay = () => {
  return <div className="blurred-modal-overlay"></div>;
};
